<template>
  <div id="chart-table-box">
    <chart-title leftTitle="WMS缺物料预警 center_4">
      <!-- <el-button
        type="primary"
        slot="detail"
        size="mini"
        style="margin-right: 20px"
        @click="handleDetail"
        >详 情</el-button
      > -->
    </chart-title>
    <div id="chart-table">
      <dv-scroll-board
        :config="config"
        style="width: 100%; height: calc(100% - 5px)"
      />
    </div>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
export default {
  mixins: [resize],
  name: "center_4",
  components: { ChartTitle },
  data() {
    return {
      config: {
        header: [
          "物料名称",
          "物料规格",
          "物料备注",
          "库存",
          "预用数量",
          "批次预出库",
          "预警数量",
        ],
        indexHeader: "序号",
        // headerBGC: "transparent", // 表头背景色
        oddRowBGC: "transparent", // 奇数行背景色
        evenRowBGC: "transparent", // 偶数行背景色
        waitTime: 2000, // 轮播时间间隔(ms)
        align: [
          "center",
          "center",
          "center",
          "center",
          "center",
          "center",
          "center",
        ],
        columnWidth: [100, 120, 110, 60],
        data: [
          [
            `<span style="color:#409EFF">ENF板双色</span>`,
            `<span style="color:#409EFF">09L-秋水长天+白1220*2440</span>`,
            `<span style="color:#409EFF">1220*2440*9</span>`,
            `<span style="color:#409EFF">14</span>`,
            `<span style="color:#409EFF">5</span>`,
            `<span style="color:#409EFF">14</span>`,
            `<span style="color:#409EFF">-5</span>`,
          ],
          [
            `<span style="color:#409EFF">ENF板双色</span>`,
            `<span style="color:#409EFF">09L-秋水长天+白1220*2440</span>`,
            `<span style="color:#409EFF">1220*2440*9</span>`,
            `<span style="color:#409EFF">14</span>`,
            `<span style="color:#409EFF">5</span>`,
            `<span style="color:#409EFF">14</span>`,
            `<span style="color:#409EFF">-5</span>`,
          ],
          [
            `<span style="color:#409EFF">ENF板双色</span>`,
            `<span style="color:#409EFF">09L-秋水长天+白1220*2440</span>`,
            `<span style="color:#409EFF">1220*2440*9</span>`,
            `<span style="color:#409EFF">14</span>`,
            `<span style="color:#409EFF">5</span>`,
            `<span style="color:#409EFF">14</span>`,
            `<span style="color:#409EFF">-5</span>`,
          ],
          [
            `<span style="color:#409EFF">ENF板双色</span>`,
            `<span style="color:#409EFF">09L-秋水长天+白1220*2440</span>`,
            `<span style="color:#409EFF">1220*2440*9</span>`,
            `<span style="color:#409EFF">14</span>`,
            `<span style="color:#409EFF">5</span>`,
            `<span style="color:#409EFF">14</span>`,
            `<span style="color:#409EFF">-5</span>`,
          ],
          [
            `<span style="color:#409EFF">ENF板双色</span>`,
            `<span style="color:#409EFF">09L-秋水长天+白1220*2440</span>`,
            `<span style="color:#409EFF">1220*2440*9</span>`,
            `<span style="color:#409EFF">14</span>`,
            `<span style="color:#409EFF">5</span>`,
            `<span style="color:#409EFF">14</span>`,
            `<span style="color:#409EFF">-5</span>`,
          ],
          [
            `<span style="color:#409EFF">ENF板双色</span>`,
            `<span style="color:#409EFF">09L-秋水长天+白1220*2440</span>`,
            `<span style="color:#409EFF">1220*2440*9</span>`,
            `<span style="color:#409EFF">14</span>`,
            `<span style="color:#409EFF">5</span>`,
            `<span style="color:#409EFF">14</span>`,
            `<span style="color:#409EFF">-5</span>`,
          ],
          [
            `<span style="color:#409EFF">ENF板双色</span>`,
            `<span style="color:#409EFF">09L-秋水长天+白1220*2440</span>`,
            `<span style="color:#409EFF">1220*2440*9</span>`,
            `<span style="color:#409EFF">14</span>`,
            `<span style="color:#409EFF">5</span>`,
            `<span style="color:#409EFF">14</span>`,
            `<span style="color:#409EFF">-5</span>`,
          ],
          [
            `<span style="color:#409EFF">ENF板双色</span>`,
            `<span style="color:#409EFF">09L-秋水长天+白1220*2440</span>`,
            `<span style="color:#409EFF">1220*2440*9</span>`,
            `<span style="color:#409EFF">14</span>`,
            `<span style="color:#409EFF">5</span>`,
            `<span style="color:#409EFF">14</span>`,
            `<span style="color:#409EFF">-5</span>`,
          ],
        ],
      },
    };
  },
  props: {},
  created() {},
  mounted() {},

  methods: {
    handleDetail() {
      window.open(`${process.env.VUE_APP_SP_URL}/#/128_p/139_p`, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-table-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 27vh;
  #chart-table {
    height: calc(100% - 30px);
    background: transparent;
    padding: 10px 20px 0;
  }
}
</style>
<style lang="scss">
#chart-table {
  .dv-scroll-board {
    .header {
      background-color: transparent !important;
      background: radial-gradient(
        rgba(89, 132, 173, 0.45) 20%,
        rgba(89, 132, 173, 0.05) 70%
      );
      color: #8fb5db;
    }
  }
}
</style>
